import { cva, cx, type VariantProps } from '@/cva.config';
import type React from 'react';
import type { HTMLAttributes } from 'react';

export const headingVariants = cva({
  base: 'block w-full',
  variants: {
    alignment: {
      center: 'text-center',
      left: 'text-left',
    },
    h1Variant: {
      default: null,
      small: null,
    },
    size: {
      h1: null,
      h2: null,
      h3: null,
      h4: null,
    },
    textWrap: {
      balanced: 'text-balance',
      none: 'text-nowrap',
      pretty: 'text-pretty',
      standard: 'text-wrap',
    },
  },
  compoundVariants: [
    {
      h1Variant: 'small',
      size: 'h1',
      class: 'lg:text-11xl',
    },
  ],
});

interface HeadingProps
  extends HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  text?: string;
}

export const ReactHeading: React.FC<HeadingProps> = ({
  alignment,
  children,
  className,
  h1Variant = 'default',
  size = 'h2',
  text,
  textWrap = 'pretty',
  ...props
}) => {
  const HeadingTag = size;

  return (
    <HeadingTag
      className={cx(
        headingVariants({ alignment, h1Variant, size, textWrap }),
        className,
      )}
      {...props}
    >
      {text || children}
    </HeadingTag>
  );
};
